<template>
  <div class="container" id="about">
    <h1 class="section_title" v-if="custom.title">{{ custom.title }}</h1>
    <div
      class="wrapper md:wrapper-md"
      :class="{ reverse: custom.text.position == 'left' }"
    >
 
        <div v-if="html" v-html="custom.text.content" class="custom_text w-2/3 section_text md:pt-4"></div>
    


  </div>
</div>
</template>

<script>
export default {
  props: ["custom", "html"],
  methods: {
    styleObj(item) {
      var styleObj = {
        background: '#000',
        color: '#fff'
      };
      if (item.background) {
        styleObj["background"] = item.background;
      };
      if (item.color) {
        styleObj["color"] = item.color;
      };
      return styleObj;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 80%;
  @apply mx-auto mt-10;
}
.custom_text {
  /deep/ ul {
   @apply pl-6 py-4;
  list-style-type: disc;
}
/deep/ a {
   @apply font-bold underline;
}
}
</style>
